module.exports = __webpack_public_path__ + "img/logo.ae1319f5.png";